import {DateRange} from '../../../Domain/DateRange';
import {Distance} from '../../../Domain/Distance';
import {Duration} from '../../../Domain/Duration';

export interface WorkoutsTableFilter {
    page: number;
    dateRange?: DateRange;
    title?: string;
    distanceRange?: {min: Distance | null; max: Distance | null};
    durationRange?: {min: Duration | null; max: Duration | null};
}

export function serialise(filter: WorkoutsTableFilter | null): object | null {
    if (filter === null) {
        return null;
    }
    const serialised: any = {};
    if (filter.page) {
        serialised.page = filter.page;
    }
    if (filter.dateRange) {
        serialised.dateRange = {
            from: filter.dateRange.from?.toISOString(),
            till: filter.dateRange.till?.toISOString(),
        };
    }

    if (filter.title) {
        serialised.title = filter.title;
    }

    if (filter.distanceRange) {
        serialised.distanceRange = {
            min: filter.distanceRange.min?.kilometers,
            max: filter.distanceRange.max?.kilometers,
        };
    }

    if (filter.durationRange) {
        serialised.durationRange = {
            min: filter.durationRange.min?.minutes,
            max: filter.durationRange.max?.minutes,
        };
    }

    return serialised;
}

export function deserialise(serialised: object | any | null): WorkoutsTableFilter | null {
    if (serialised === null) {
        return null;
    }

    return {
        page: serialised.page || 1,
        dateRange: serialised.dateRange
            ? {
                  from: serialised.dateRange.from ? new Date(serialised.dateRange.from) : null,
                  till: serialised.dateRange.till ? new Date(serialised.dateRange.till) : null,
              }
            : undefined,
        title: serialised.title,
        distanceRange: serialised.distanceRange
            ? {
                  min: serialised.distanceRange.min ? Distance.fromKilometers(serialised.distanceRange.min) : null,
                  max: serialised.distanceRange.max ? Distance.fromKilometers(serialised.distanceRange.max) : null,
              }
            : undefined,
        durationRange: serialised.durationRange
            ? {
                  min: serialised.durationRange.min ? Duration.fromMinutes(serialised.durationRange.min) : null,
                  max: serialised.durationRange.max ? Duration.fromMinutes(serialised.durationRange.max) : null,
              }
            : undefined,
    };
}
